import * as React from "react";

import "./delivery-methods.scss";

import {cs}          from "@Common/react/chain-services";
import {Invoke}      from "@Common/react/invoke";
import {scopedState} from "@Common/react/scoped-state";

export const DeliveryMethods = ({componentState, templateOptions, defaultMethod, item}) => cs(
    ["state", (_, next) => next(scopedState(componentState, ['selections', 'distributionType']))],
    ["availableMethods", (_, next) => next(
        templateOptions.distributions
            .filter((distribution) => distribution !== "mailing")
            .filter((method) => method !== "pickup" || item?.programType !== "Scheduled Campaigns")
    )],
    ({state, availableMethods}, next) => !state.value ? Invoke({ fn: () => state.onChange(availableMethods.includes(defaultMethod) ? defaultMethod : availableMethods[0]) }) : next(),
    ({availableMethods}) => availableMethods.length === 0 && (
        <div className="delivery-methods-8d3">
            <div className="card error">
                This template does not currently have delivery options configured. Please choose another template or contact customer service.
            </div>
        </div>
    )
);
